import { z } from "zod";

export const verifyOtpSchema = z.object({
	email: z.email({ message: "Email is required" }).transform((e) => e.toLowerCase()),
	code: z.string().length(6, { message: "Code must be 6 digits" }),
});

export type VerifyOtpPayload = z.infer<typeof verifyOtpSchema>;
